import React, { useState } from "react";
import { Route, BrowserRouter, NavLink, Routes } from 'react-router-dom';
import MicroFrontend from "./MicroFrontend";
import { 
  Layout, 
  Menu, 
  Card, 
  Avatar, 
  Row, 
  Col, 
  Statistic, 
  Button, 
  Space,
  Typography
} from 'antd';
import {
  UserOutlined,
  CalendarOutlined,
  MedicineBoxOutlined,
  BellOutlined,
  SettingOutlined,
  PlusOutlined,
  HomeOutlined,
  TeamOutlined,
  FileTextOutlined,
  ScheduleOutlined,
  ExperimentOutlined,
  MenuOutlined,
  CloseOutlined
} from '@ant-design/icons';

const { Header, Content, Sider } = Layout;
const { Title, Text } = Typography;

const {
  REACT_APP_SUBAPP1_HOST: subapp1 = "http://localhost:4001/",
  REACT_APP_SUBAPP2_HOST: subapp2 = "http://localhost:4002/"
} = process.env;

const SubApp2 = ({ history }) => (
  <MicroFrontend history={history} host={subapp2} name="subapp2" />
);

const SubApp1 = ({ history }) => (
  <MicroFrontend history={history} host={subapp1} name="subapp1" />
);

const Home = () => {
  return (
    <Content style={{ padding: '24px', background: '#f8fafc' }}>
      {/* Dashboard Stats Row */}
      <Row gutter={[24, 24]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} style={{ borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <Statistic
              title={<Text type="secondary">Total Patients</Text>}
              value={2458}
              prefix={<TeamOutlined style={{ color: '#3182ce', background: '#ebf5ff', padding: '8px', borderRadius: '8px' }} />}
              valueStyle={{ color: '#2d3748', fontSize: '28px', fontWeight: 700 }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} style={{ borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <Statistic
              title={<Text type="secondary">Today's Appointments</Text>}
              value={37}
              prefix={<CalendarOutlined style={{ color: '#38a169', background: '#f0fff4', padding: '8px', borderRadius: '8px' }} />}
              valueStyle={{ color: '#2d3748', fontSize: '28px', fontWeight: 700 }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} style={{ borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <Statistic
              title={<Text type="secondary">Pending Consultations</Text>}
              value={12}
              prefix={<MedicineBoxOutlined style={{ color: '#dd6b20', background: '#fffaf0', padding: '8px', borderRadius: '8px' }} />}
              valueStyle={{ color: '#2d3748', fontSize: '28px', fontWeight: 700 }}
            />
          </Card>
        </Col>
      </Row>

      {/* Main Content Area */}
      <Row gutter={[24, 24]}>
        {/* Recent Patients Card */}
        <Col xs={24} lg={12}>
          <Card 
            bordered={false} 
            style={{ borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginBottom: '16px' }}
            title={<Title level={5} style={{ color: '#3182ce', margin: 0 }}>Recent Patients</Title>}
          >
            {['Sarah Johnson', 'Michael Chen', 'Emma Wilson', 'James Rodriguez'].map((patient, index) => (
              <div 
                key={index} 
                style={{ 
                  padding: '12px',
                  borderRadius: '8px',
                  background: '#f7fafc',
                  marginBottom: '8px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Avatar 
                  style={{ 
                    backgroundColor: '#ebf5ff',
                    color: '#3182ce',
                    marginRight: '12px'
                  }}
                  size="large"
                >
                  {patient.charAt(0)}
                </Avatar>
                <div>
                  <Text strong style={{ display: 'block' }}>{patient}</Text>
                  <Text type="secondary" style={{ fontSize: '12px' }}>Last visit: 2h ago</Text>
                </div>
              </div>
            ))}
          </Card>
        </Col>

        {/* Upcoming Appointments */}
        <Col xs={24} lg={12}>
          <Card 
            bordered={false} 
            style={{ borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginBottom: '16px' }}
            title={<Title level={5} style={{ color: '#3182ce', margin: 0 }}>Upcoming Appointments</Title>}
          >
            {[
              { time: '2:30 PM', patient: 'Sarah Johnson', type: 'Follow-up' },
              { time: '4:15 PM', patient: 'Robert Lewis', type: 'Lab Results' },
              { time: '5:00 PM', patient: 'Linda Thompson', type: 'Consultation' }
            ].map((appt, index) => (
              <div 
                key={index} 
                style={{ 
                  padding: '12px',
                  borderRadius: '8px',
                  background: '#f7fafc',
                  marginBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <Space>
                  <div>
                    <Text strong style={{ display: 'block' }}>{appt.time}</Text>
                    <Text type="secondary" style={{ fontSize: '12px' }}>{appt.type}</Text>
                  </div>
                </Space>
                <Text strong>{appt.patient}</Text>
                <Button type="primary" size="small">View</Button>
              </div>
            ))}
          </Card>
        </Col>
      </Row>

      {/* Quick Actions */}
      <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
        {[
          { label: 'New Patient', icon: <PlusOutlined /> },
          { label: 'Schedule', icon: <ScheduleOutlined /> },
          { label: 'Prescription', icon: <FileTextOutlined /> },
          { label: 'Lab Report', icon: <ExperimentOutlined /> }
        ].map((action, index) => (
          <Col key={index} xs={24} sm={12} md={6}>
            <Button 
              type="primary" 
              icon={action.icon}
              size="large"
              style={{ 
                height: 'auto',
                padding: '16px 8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '8px'
              }}
              block
            >
              {action.label}
            </Button>
          </Col>
        ))}
      </Row>
    </Content>
  );
};

const App = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <BrowserRouter>
      <Layout style={{ minHeight: '100vh' }}>
        {/* Sidebar */}
        <Sider
          width={280}
          style={{
            background: '#1a365d',
            boxShadow: '2px 0 8px rgba(0, 0, 0, 0.1)',
            position: 'fixed',
            height: '100vh',
            zIndex: 100,
            left: 0,
            top: 0,
            bottom: 0
          }}
          breakpoint="lg"
          collapsedWidth="0"
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          trigger={null}
        >
          <div style={{
            padding: '24px 24px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '8px'
          }}>
            <div style={{
              width: '40px',
              height: '40px',
              background: '#fff',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#1a365d',
              fontWeight: 'bold',
              fontSize: '18px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              O
            </div>
            <Title level={4} style={{ color: '#fff', margin: 0, letterSpacing: '0.5px' }}>
              Orglance Health
            </Title>
          </div>

          <Menu
            theme="dark"
            mode="inline"
            style={{ 
              background: 'transparent', 
              borderRight: 'none',
              padding: '0 12px'
            }}
          >
            <Menu.Item 
              key="1" 
              icon={<HomeOutlined style={{ fontSize: '20px' }} />}
              style={{
                height: '56px',
                marginBottom: '8px',
                borderRadius: '12px'
              }}
            >
              <NavLink to="/home" style={{ fontSize: '16px', fontWeight: 600 }}>Dashboard</NavLink>
            </Menu.Item>
            <Menu.Item 
              key="2" 
              icon={<UserOutlined style={{ fontSize: '20px' }} />}
              style={{
                height: '56px',
                marginBottom: '8px',
                borderRadius: '12px'
              }}
            >
              <NavLink to="/subapp1" style={{ fontSize: '16px', fontWeight: 600 }}>Patient Records</NavLink>
            </Menu.Item>
            <Menu.Item 
              key="3" 
              icon={<MedicineBoxOutlined style={{ fontSize: '20px' }} />}
              style={{
                height: '56px',
                marginBottom: '8px',
                borderRadius: '12px'
              }}
            >
              <NavLink to="/subapp2" style={{ fontSize: '16px', fontWeight: 600 }}>Pharmacy Portal</NavLink>
            </Menu.Item>
          </Menu>
          
          {/* User profile section */}
          <div style={{
            position: 'fixed',
            bottom: '20px',
            left: '16px',
            width: '248px',
            padding: '16px',
            borderRadius: '12px',
            background: 'rgba(255, 255, 255, 0.1)'
          }}>
            <Space>
              <Avatar 
                size="large"
                style={{ 
                  backgroundColor: '#4299e1',
                  color: 'white'
                }} 
              >
                DR
              </Avatar>
              <div>
                <Text strong style={{ color: '#fff', display: 'block' }}>Dr. Roberts</Text>
                <Text style={{ color: 'rgba(255, 255, 255, 0.65)', fontSize: '12px' }}>Administrator</Text>
              </div>
            </Space>
          </div>
        </Sider>

        {/* Main Content Area */}
        <Layout style={{ 
          marginLeft: collapsed ? 0 : 280,
          transition: 'margin 0.2s'
        }}>
          <Header style={{ 
            background: '#fff',
            padding: '0 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
            position: 'sticky',
            top: 0,
            zIndex: 10
          }}>
            <Button 
              type="text" 
              icon={collapsed ? <MenuOutlined /> : <CloseOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ 
                display: 'none',
                '@media (max-width: 991px)': { 
                  display: 'block' 
                }
              }}
            />
            <Title level={4} style={{ margin: 0, color: '#3182ce' }}>
              Welcome to Orglance Health
            </Title>
            <Space size="middle">
              <Button type="text" icon={<BellOutlined />} />
              <Button type="text" icon={<SettingOutlined />} />
            </Space>
          </Header>
          <Content style={{ 
            margin: '24px 16px',
            overflow: 'initial',
            padding: '24px',
            background: '#f8fafc',
            minHeight: 'calc(100vh - 112px)'
          }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/subapp1" element={<SubApp1 />} />
              <Route path="/subapp2" element={<SubApp2 />} />
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </BrowserRouter>
  );
};

export default App;